// import React, { useState } from 'react';
// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { auth } from '../firebase';
// import { useNavigate, Link } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const loginHandler = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);
    
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigate('/');
//     } catch (err) {
//       console.error("Login error:", err.message);
//       setError('Invalid email or password');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="vh-100 d-flex align-items-center justify-content-center" style={{background: 'linear-gradient(to right, #667eea, #764ba2)'}}>
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-md-6 col-lg-4">
//             <div className="card border-0 shadow-lg">
//               <div className="card-body p-5">
//                 <div className="text-center mb-4">
//                   <h2 className="fw-bold">Welcome Back</h2>
//                   <p className="text-muted">Sign in to continue</p>
//                 </div>
                
//                 {error && (
//                   <div className="alert alert-danger py-2 fade show">
//                     <i className="bi bi-exclamation-circle me-2"></i>
//                     {error}
//                   </div>
//                 )}
                
//                 <form onSubmit={loginHandler}>
//                   <div className="form-floating mb-3">
//                     <input 
//                       type="email" 
//                       className="form-control" 
//                       id="email"
//                       placeholder="name@example.com" 
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       required
//                     />
//                     <label htmlFor="email">Email address</label>
//                   </div>
                  
//                   <div className="form-floating mb-4">
//                     <input 
//                       type="password" 
//                       className="form-control" 
//                       id="password"
//                       placeholder="Password" 
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       required
//                     />
//                     <label htmlFor="password">Password</label>
//                   </div>
                  
//                   <div className="d-grid">
//                     <button 
//                       type="submit" 
//                       className="btn btn-primary py-3"
//                       disabled={loading}
//                     >
//                       {loading ? 'Signing In...' : 'Sign In'}
//                     </button>
//                   </div>
//                 </form>
                
//                 <div className="text-center mt-4">
//                   <p className="text-muted mb-0">
//                     Don't have an account? <Link to="/register" className="text-primary fw-bold">Sign Up</Link>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // ✅ Make sure this file exports `auth`
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const loginHandler = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'linear-gradient(to right, #667eea, #764ba2)', fontFamily: 'Poppins, sans-serif' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-lg rounded-4">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold">Welcome Back</h2>
                  <p className="text-muted small">Fine Management Login</p>
                </div>

                {error && (
                  <div className="alert alert-danger py-2 fade show text-center">
                    {error}
                  </div>
                )}

                <form onSubmit={loginHandler}>
                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="name@example.com"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <label htmlFor="email">Email address</label>
                  </div>

                  <div className="form-floating mb-4">
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label htmlFor="password">Password</label>
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary py-3 fw-semibold">
                      Sign In
                    </button>
                  </div>
                </form>

                {/* <div className="text-center mt-4">
                  <small className="text-muted">
                    Don't have an account?{' '}
                    <a href="/signup" className="text-decoration-none fw-bold text-primary">Register</a>
                  </small>
                </div> */}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
